exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box-btn[data-v-50b996ac] {\n  border: none;\n  outline: border;\n  cursor: pointer;\n  background-color: transparent;\n  opacity: 1;\n  -webkit-transition: all .3s;\n  transition: all .3s;\n}\n.box-text[data-v-50b996ac] {\n  font-weight: lighter;\n  line-height: 17px;\n  color: #353635;\n}\n.bold[data-v-50b996ac] {\n  font-weight: bold;\n}\n.spaced-labels[data-v-50b996ac] {\n  margin-left: 7px;\n}\n.disabled-box-btn[data-v-50b996ac] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50b996ac","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/form/customItems/CheckBox.vue
// module id = 9gpN
// module chunks = 53